import React, {useEffect, useState} from "react";
import Select, {components} from "react-select";
import {Arrow} from "BaseComponents/Icons/Svg";
import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {useGlobal} from "reactn";
import queryString from "query-string";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <Arrow color="#000" rotate={props.isFocused ? "-90" : "90"}/>
    </components.DropdownIndicator>
  );
};

export const MapDropdowns = ({
                               municipalities,
                               units,
                               types,
                               onChange,
                               NoHits,
                               SearchMunicipality,
                               SearchMunicipalityHint,
                               SearchUnit,
                               handleOverlay,
                               SearchUnitHint,
                               SearchTypeLabel,
                               SearchTypeHint,
                               ShowPreschoolTypes,
                               ShowUnitTypes,
                               disabledMunicipality = false
                             }) => {
  const [theme] = useGlobal("theme");
  const customStyles = {
    option: (provided, {data, isDisabled, isFocused, isSelected}) => ({
      ...provided,
      color: isSelected ? "white" : "black",
      padding: 15,
      cursor: "pointer",
      background: isSelected ? theme.colors.gradient : "white",
      border: isFocused ? "1px solid #515151" : "none",
      boxShadow: isFocused ? "0px 0px -10px #515151" : "none",
      "&:hover": {
        background: isSelected ? theme.colors.primaryDark : "#f7f7f7",
      },
    }),

    control: (provided, {isFocused}) => ({
      ...provided,
      width: "auto",
      padding: "7px 10px",
      border: "1px solid #515151",
      borderColor: "#949494",
      cursor: "text",
      boxShadow: "none",
      outline: isFocused ? "#515151 solid 2px " : "0",
      outlineOffset: "5px",
      "&:hover": {
        borderColor: theme.colors.primary,
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      fontFamily: theme.font,
    }),
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: theme.font,
      color: "black",
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      cursor: "pointer",
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 1001,
      fontFamily: theme.font,
    }),
    indicatorSeparator: () => ({
      cursor: "pointer",
    }),
    IndicatorsContainer: () => ({
      marginRight: "80px",
      cursor: "pointer",
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return {
        ...provided,
        opacity,
        transition,
      };
    },
    multiValueRemove: (styles, {isFocused}) => ({
      ...styles,
      cursor: "pointer",
      outline: isFocused ? "#515151 solid 2px " : "0",
      outlineOffset: "2px",
    })
  };

  const unitsDropdownStyle = {
    ...customStyles,
    dropdownIndicator: () => ({
      display: "none",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      cursor: "pointer",
    }),
    menu: (styles) => ({
      ...styles,
      zIndex: 1001,
    }),
    control: (provided, {isFocused}) => ({
      ...provided,
      width: "auto",
      padding: "7px 10px",
      border: "1px solid #515151",
      borderColor: "#949494",
      cursor: "text",
      boxShadow: "none",
      outline: isFocused ? "#515151 solid 2px " : "0",
      outlineOffset: "5px",
      "&:hover": {
        borderColor: theme.colors.primary,
      },
    }),
    multiValueRemove: (styles, {isFocused}) => ({
      ...styles,
      cursor: "pointer",
      outline: isFocused ? "#515151 solid 2px " : "0",
      outlineOffset: "2px",
    })
  };
  const [selectedMunicipality, setSelectedMunicipality] = useState("");
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const selectedMunicipalityExists = () =>
    selectedMunicipality !== null && selectedMunicipality.label !== undefined;
  const selectedUnitExists = () =>
    selectedUnit !== null && selectedUnit.label !== undefined;

  const onDropdownChange = (selected, type) => {
    switch (type) {
      case "unit":
        if (selected === null) {
          if (selectedMunicipalityExists()) {
            selected = selectedMunicipality;
            type = "municipality";
          } else {
            selected = null;
            type = "municipality";
          }
          setSelectedUnit("");
        } else {
          setSelectedUnit(selected);
        }
        break;
      case "municipality":
        if (selected === null) {
          if (selectedUnit !== null && selectedUnit.label !== undefined) {
            selected = selectedUnit;
            type = "unit";
          }
          setSelectedMunicipality("");
        } else {
          setSelectedMunicipality(selected);
        }
        break;
      case "preSchoolType":
        if (selected === null) {
          if (selectedMunicipalityExists()) {
            selected = selectedMunicipality;
            type = "municipality";
          } else {
            type = "municipality";
            selected = null;
          }
          setSelectedType("");
          setSelectedUnit("");
        } else {
          setSelectedType(selected);
        }
        break;
    }
    onChange(selected, type);
  };

  useEffect(() => {
    if (window.location.search && types.length > 0) {
      const parsed = queryString.parse(window.location.search);
      if (parsed.preschooltype) {
        let typeItems = [];
        if (typeof (parsed.preschooltype) == "string") {
          const data = parsed.preschooltype.split(',');
          data.map((c) => {
            const value = types.find((t) => t.value.toLowerCase() === c.toLowerCase());
            if (value) {
              typeItems.push(value);
            }
          });
          setSelectedType(typeItems);

        } else {
          parsed.preschooltype.map((c) => {
            const value = types.find((t) => t.value.toLowerCase() === c.toLowerCase());
            if (value) {
              typeItems.push(value);
            }
          });
          setSelectedType(typeItems);
        }
        onChange(typeItems, 'preSchoolType');
      }
    }
  }, [types]);
  useEffect(() => {
    if (selectedMunicipalityExists()) {
      if (units.length === 1 && selectedType !== null) {
        setSelectedUnit(units);
      } else if (units.length > 1) {
        let _unit = units.filter(
          (el, i) =>
            selectedUnit.length &&
            i === units.findIndex((elem) => elem.name === selectedUnit[0].label)
        );
        setSelectedUnit(_unit.length ? [_unit] : "");
      }
    } else if (selectedUnitExists()) {
      onChange(selectedUnit, "unit");
    } else {
      setSelectedUnit("");
    }

    if (municipalities?.length === 1) {
      setSelectedMunicipality(municipalities[0]);
    }

  }, [municipalities]);

  return (
    <OuterWrapper>
      <InnerWrapper>
        <DropdownLabel>{SearchMunicipality}</DropdownLabel>
        <Select
          isClearable={true}
          styles={customStyles}
          placeholder={SearchMunicipalityHint}
          isSearchable={true}
          options={municipalities}
          components={{
            DropdownIndicator,
          }}
          onFocus={() => handleOverlay()}
          noOptionsMessage={() => NoHits}
          noOptionsMessage={() => NoHits}
          value={selectedMunicipality}
          onChange={(selectedMunicipality) =>
            onDropdownChange(selectedMunicipality, "municipality")
          }
          isDisabled={disabledMunicipality}
        />
      </InnerWrapper>
      {ShowPreschoolTypes && (
        <InnerWrapper>
          <DropdownLabel>{SearchTypeLabel}</DropdownLabel>
          <Select
            isMulti
            isClearable={true}
            isSearchable={true}
            styles={customStyles}
            placeholder={SearchTypeHint}
            options={types}
            components={{
              DropdownIndicator,
            }}
            onFocus={() => handleOverlay()}
            value={selectedType}
            noOptionsMessage={() => NoHits}
            onChange={(selectedType) =>
              onDropdownChange(selectedType, "preSchoolType")
            }
          />
        </InnerWrapper>
      )}
      {ShowUnitTypes && (
        <InnerWrapper>
          <DropdownLabel>{SearchUnit}</DropdownLabel>
          <Select
            isClearable={true}
            isSearchable={true}
            styles={unitsDropdownStyle}
            placeholder={SearchUnitHint}
            options={units}
            components={{
              DropdownIndicator,
            }}
            onFocus={() => handleOverlay()}
            value={selectedUnit}
            noOptionsMessage={() => NoHits}
            onChange={(selectedUnit) => onDropdownChange(selectedUnit, "unit")}
          />
        </InnerWrapper>
      )}
    </OuterWrapper>
  );
};

const OuterWrapper = styled.div`
    display: flex;
    width: 100%;
    font-family: ${({theme}) => theme.font};
    flex-direction: column;
    margin: 1rem 0 1rem 0;

    ${media.greaterThan(breakpoints.ipad)`
    flex-direction: row;
    margin: 2rem 0 1rem 0;
  `}
`;

const InnerWrapper = styled.div`
    flex-basis: 30%;
    flex-grow: 1;
    display: flex;
    flex-direction: column;

    & + & {
        margin: 1rem 0 0 0;
    }

    ${media.greaterThan(breakpoints.ipad)`
    flex-basis: 30%;
    flex-grow: 0;
    & + & {
      margin: 0 0 0 1rem;
    }
  `}
`;

const DropdownLabel = styled.span`
    font-weight: bold;
    margin: 0 0 5px 0;
    color: #333333;
    font-size: 16px;
`;
